import { render, staticRenderFns } from "./icon-select.vue?vue&type=template&id=7534eec0"
import script from "./icon-select.vue?vue&type=script&lang=js"
export * from "./icon-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports